<template>
  <div>
    <Header />
    <ClaimInvoices :store-id="selectedStoreId" claim-details-route-prefix="/store/claim" />
  </div>
</template>

<script>
import ClaimInvoices from "@/components/billing/claim_invoice/ClaimInvoices.vue";
import Header from "@/views/store/claim/Header.vue";
import { mapState } from "vuex";

export default {
  components: {
    ClaimInvoices,
    Header,
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
  },
};
</script>
